import { render, staticRenderFns } from "./DeleteCATQuestionButton.vue?vue&type=template&id=2fbac730&"
import script from "./DeleteCATQuestionButton.vue?vue&type=script&lang=js&"
export * from "./DeleteCATQuestionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports